<template>
    <a-card>
      
    <div>
        <h3 style="text-align: center;margin:20px 0 40px">项目规模、指标和验收内容</h3>
        <a-form layout="vertical"  ref="ruleForm" labelAlign="right" :model="form" :rules="rules" >
            <!--可编辑区域 start-->
            <div class="hidden">
                <!-- <div > -->
                <a-col :span="24">
                    <a-form-item label="ID主键" name="id">
                        <a-input v-model:value="form.id" placeholder="请输入ID主键" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="项目ID" name="projectId">
                        <a-input v-model:value="form.projectId" placeholder="请输入项目ID" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="分类ID" name="classification">
                        <a-input v-model:value="form.classification" placeholder="请输入分类ID" />
                    </a-form-item>
                </a-col>
            </div>
            <a-row :gutter="[24,8]">
                <a-col :span="24">
                    <a-form-item label="项目规模" name="projectScale">
                        <a-textarea v-model:value="form.projectScale" placeholder="请输入项目规模" :auto-size="{minRows:3,maxRows:6}" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="项目完成达到的主要技术指标" name="projectSpecification">
                        <a-textarea v-model:value="form.projectSpecification" placeholder="请输入项目完成达到的主要技术指标" :auto-size="{minRows:3,maxRows:6}" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="项目完成达到的经济指标" name="projectEconomic">
                        <a-textarea v-model:value="form.projectEconomic" placeholder="请输入项目完成达到的经济指标" :auto-size="{minRows:3,maxRows:6}" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="验收内容" name="acceptanceContent">
                        <a-checkbox-group v-model:value="form.acceptanceContent">
                            <a-checkbox v-for="(item,key) in optionCheck" :key="key" :value="item.value" name="type">{{item.name}}</a-checkbox>
                        </a-checkbox-group>
                    </a-form-item>
                </a-col>
                <a-col :span="24" style="text-align: center;">
                    <a-button type="primary" html-type="submit" @click="onSubmit">
                        项目规模、指标和验收内容保存
                    </a-button>
                </a-col>
            </a-row>
        </a-form>
        
    </div>
    </a-card>
</template>
<script>
import { postAction, postJson } from "@/utils/http/service";
import { filterObj } from "@/utils/util";
import store from '@/store';
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {projectCheck} from "@/api/TechnologieprojekteApply";

export default {
    name: "项目规模、指标和验收内容",
    components: {},

    mixins: [formMixin],
    data() {
        return {
            optionCheck:[{
                name:'技术报告',
                value:'0'
            },{
                name:'计算机软件',
                value:'1'
            },{
                name:'生物品种',
                value:'2'
            },{
                name:'样品或样机',
                value:'3'
            },{
                name:'成套技术设备',
                value:'4'
            }],
            form: {
                    id: null,
                    projectId: store.getters.TechnologieTypeId.projectId,
                    classification: store.getters.TechnologieTypeId.classification,
                    projectScale: null,
                    projectSpecification: null,
                    projectEconomic: null,
                    acceptanceContent: null,
            },
            rules: {
                    id: [],
                    projectId: [
                        dataCheck.required({}),
                    ],
                    classification: [
                        dataCheck.required({}),
                    ],
                    projectScale: [
                        dataCheck.required({}),
                    ],
                    projectSpecification: [
                        dataCheck.required({}),
                    ],
                    projectEconomic: [
                        dataCheck.required({}),
                    ],
                    acceptanceContent: [
                    ]
            },

            options: [],

        }
    },
    
    computed: {
            submitUrl() {
                return projectCheck.saveOrUpdate
            }
        },
    mounted() {
        if(this.$route.query.id){
            this.onEdit()
        }
    },
    methods: {
        /*提交表单操作*/
        onSubmit() {
            this.form.acceptanceContent = this.form.acceptanceContent.toString()
            console.log(this.form.acceptanceContent)
            if (!this.submitUrl) {
                this.$notification.warning({
                    message: '提示',
                    description: '请设置表单操作url地址',
                });
            } else {
                this.$refs.ruleForm
                    .validate()
                    .then(() => {
                        this.confirmLoading = true;
                        let params = this.transformParams
                            ? this.transformParams(this.form)
                            : this.form;
                            let action;
                        /*后台请求*/
                        if(this.submitType == 'json'){
                            action = postJson({
                                url: this.submitUrl,
                                params: filterObj(this.getSubmitParams(params)),
                                method: this.postMethod,
                                returnMsg: true
                            })
                        }else{
                            action=  postAction({
                                url: this.submitUrl,
                                params: filterObj(this.getSubmitParams(params)),
                                method: this.postMethod,
                                returnMsg: true
                            })
                        }
                        action.then((res) => {
                            this.$parent.$parent.postData(res.data.classification,res.data.projectId)
                            this.confirmLoading = false;
                            this.$notification.success({
                                message: '提示',
                                description: res.msg || '操作成功',
                            });
                            if (this.onSuccessFn) {
                                this.onSuccessFn(res);
                            }
                            if (this.isModal) {
                                this.$emit('finish');
                                this.onClose();
                            }
                        }).catch(() => {
                            this.confirmLoading = false;
                        })
                    })
                    .catch(error => {
                        if(error.errorFields.length){
                            this.$parent.$parent.errorSet()
                            this.$notification.error({
                                message: '请检查必填项，必填项目不能不填',
                            });
                        }
                        window.console.log('error', error);
                    });
            }
        },
        onEdit() {
            this.getAction({
                url: projectCheck.detailByProject,
                params: { 
                    projectId: store.getters.TechnologieTypeId.projectId,
                    classification: store.getters.TechnologieTypeId.classification,
                 }
            }).then(res => {
                if(res){
                    this.form = res
                }
            })
        },
    },
}
</script>
<style scoped lang="less">
</style>
